import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'profile-upload-card': {
      'width': '208px',
      'height': '208px',
      '& .ant-upload-select': {
        width: '208px !important',
        height: '208px !important',
      },
      '& .ant-upload-list-item-container': {
        width: '208px !important',
        height: '208px !important',
      },
      '& .ant-upload-list-item': {
        width: '208px !important',
        height: '208px !important',
      },
      '& .ant-upload-list-item-thumbnail': {
        width: '190px !important',
        height: '190px !important',
      },
    },
    'profile-upload-card__upload-icon': {
      marginRight: '8px',
    },
  };
});

export default useStyles;
